import { render, staticRenderFns } from "./CustomTableHead.vue?vue&type=template&id=614b5b96&"
import script from "./CustomTableHead.vue?vue&type=script&lang=js&"
export * from "./CustomTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports